// extracted by mini-css-extract-plugin
export default {"navbar":"Navigation_navbar__Z0pmg"};